export default __webpack_public_path__ + "static/media/LocationMarker.33c21e80.svg";